import axios, { AxiosError } from 'axios'
import config from './config'

const isDevelopment = config.environment !== 'production';

const http = axios.create({
  baseURL: config.baseURL + '/api',
  withCredentials: false, // Set to false since we use Bearer tokens, not cookies
  timeout: 15000, // 15 second timeout (reduced for faster error feedback)
})

// Log the actual base URL being used (only in development)
if (isDevelopment) {
  console.log('🔗 Axios HTTP client configured with baseURL:', http.defaults.baseURL);
}

// Request interceptor to add auth token
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors
http.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Only clear auth for 401s from auth endpoints, not from every API call.
    // A 401 on e.g. /rooms or /matches should not force the user to log out —
    // it may be a transient server error or a protected resource the user
    // simply doesn't have access to. Matching mobile app behaviour.
    const url = (error.config as any)?.url ?? ''
    if (error.response?.status === 401 && url.includes('/auth/')) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('authData')
      window.location.href = '/login'
    }

    // Note: 404 errors for invitation endpoints are handled gracefully
    // in the service layer using validateStatus to prevent them from being
    // treated as errors. The browser may still log them in the network tab,
    // but they won't cause exceptions in our code.

    return Promise.reject(error)
  }
)

export default http
